import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { WixConnect } from 'shared/utils/wix-connect';
import { isTagsVisible } from 'shared/utils/layout-helpers';
import WixSDK from 'shared/utils/wix-sdk';

import DEVICE_TYPES from 'shared/constants/device-types';

import TagsCloud from 'widget/components/tags-cloud/tags-cloud';

import styles from './tags.styl';


@connect(state => ({
  isVisible: isTagsVisible(state.appSettings),
}))
@WixConnect(styles)
export default class Tags extends React.Component {

  static propTypes = {
    tags: React.PropTypes.array,
    className: React.PropTypes.string,
    tagClassName: React.PropTypes.string,
    roundedTagClassName: React.PropTypes.string,
    onTagFocus: React.PropTypes.func,
    onTagClick: React.PropTypes.func,
    onTagBlur: React.PropTypes.func,
    biEvent: React.PropTypes.func,
    isVisible: React.PropTypes.bool,
  };

  static defaultProps = {
    onTagClick: _.noop,
  };

  get tagList() {
    return _.map(this.props.tags || [], 'value');
  }

  sendTagSelectedBI() {
    this.props.biEvent('widget.tags.selected');
  }

  @autobind
  onTagClick(tag) {
    this.sendTagSelectedBI();
    this.props.onTagClick(tag);
  }

  render() {
    const { className, tagClassName, roundedTagClassName, isVisible, onTagFocus, onTagBlur } = this.props;

    const tagClassNames = classnames(styles.tag, tagClassName, {
      [styles.mobile]: WixSDK.Utils.getDeviceType() === DEVICE_TYPES.MOBILE,
    });

    if (!isVisible) {
      return null;
    }

    return (
      <TagsCloud className={className}
                 tagClassName={tagClassNames}
                 roundedTagClassName={roundedTagClassName}
                 tags={this.tagList}
                 onTagBlur={onTagBlur}
                 onTagFocus={onTagFocus}
                 onTagClick={this.onTagClick} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/tags/tags.js